<div class="app-datepicker-wrapper">
    <p-datepicker #datepickerComponent [ngModel]="value()" (ngModelChange)="updateValue($event)"
        [placeholder]="getPlaceholderText()" [readonlyInput]="true" [disabled]="datepickerConfig().disabled || false"
        [showIcon]="datepickerConfig().showIcon || false" [iconDisplay]="datepickerConfig().iconDisplay || 'button'"
        [selectionMode]="datepickerConfig().selectionMode || 'single'" [showTime]="datepickerConfig().showTime || false"
        [timeOnly]="datepickerConfig().timeOnly || false" [hourFormat]="datepickerConfig().hourFormat || '12'"
        [dateFormat]="datepickerConfig().dateFormat || 'mm/dd/yy'"
        [showSeconds]="datepickerConfig().showSeconds || false" [inline]="datepickerConfig().inline || false"
        [view]="datepickerConfig().view || 'date'" [touchUI]="datepickerConfig().touchUI || false"
        [showButtonBar]="datepickerConfig().showButtonBar || false"
        [showClear]="datepickerConfig().showClearButton || false" [showOnFocus]="datepickerConfig().showOnFocus"
        [autofocus]="datepickerConfig().autofocus || false" [numberOfMonths]="datepickerConfig().numberOfMonths || 1"
        [showOtherMonths]="datepickerConfig().showOtherMonths"
        [selectOtherMonths]="datepickerConfig().selectOtherMonths" [minDate]="datepickerConfig().minDate"
        [maxDate]="datepickerConfig().maxDate" [disabledDates]="datepickerConfig().disabledDates || []"
        [disabledDays]="datepickerConfig().disabledDays || []" [maxDateCount]="datepickerConfig().maxDateCount"
        [firstDayOfWeek]="datepickerConfig().firstDayOfWeek || 0" [showWeek]="datepickerConfig().showWeek || false"
        [appendTo]="datepickerConfig().appendTo" [todayButtonStyleClass]="'p-button-secondary'"
        [clearButtonStyleClass]="'p-button-secondary p-button-outlined'"
        [keepInvalid]="datepickerConfig().keepInvalid || false"
        [hideOnDateTimeSelect]="datepickerConfig().hideOnDateTimeSelect" [stepHour]="datepickerConfig().stepHour || 1"
        [stepMinute]="datepickerConfig().stepMinute || 1" [stepSecond]="datepickerConfig().stepSecond || 1"
        [showTransitionOptions]="datepickerConfig().showTransitionOptions || '0.12s cubic-bezier(0, 0, 0.2, 1)'"
        [hideTransitionOptions]="datepickerConfig().hideTransitionOptions || '0.1s linear'"
        [focusTrap]="datepickerConfig().focusTrap" [inputStyle]="datepickerConfig().inputStyle"
        [inputStyleClass]="datepickerConfig().inputStyleClass" [panelStyle]="datepickerConfig().panelStyle"
        [panelStyleClass]="datepickerConfig().panelStyleClass" (onSelect)="handleSelect($event)"
        (onInput)="handleInput($event)" (onTodayClick)="handleTodayClick()" (onClearClick)="handleClear($event)"
        (onMonthChange)="handleMonthChange($event)" (onYearChange)="handleYearChange($event)" (onShow)="handleShow()"
        (onClose)="handleClose($event)" (onFocus)="handleFocus($any($event))" (onBlur)="handleBlur($any($event))">
        <!-- Custom date cell template -->
        <ng-template pTemplate="date" let-date *ngIf="dateTemplate()">
            <ng-container *ngTemplateOutlet="dateTemplate()!; context: {
                date: date.date,
                day: date.day,
                month: date.month,
                year: date.year,
                otherMonth: date.otherMonth,
                today: date.today,
                selectable: date.selectable,
                selected: date.selected
            }"></ng-container>
        </ng-template>

        <!-- Custom header template -->
        <ng-template pTemplate="header" *ngIf="headerTemplate()">
            <ng-container *ngTemplateOutlet="headerTemplate()!"></ng-container>
        </ng-template>

        <!-- Custom footer template -->
        <ng-template pTemplate="footer" *ngIf="footerTemplate()">
            <ng-container *ngTemplateOutlet="footerTemplate()!"></ng-container>
        </ng-template>

        <!-- Custom decade template -->
        <ng-template pTemplate="decade" let-decade *ngIf="decadeTemplate()">
            <ng-container *ngTemplateOutlet="decadeTemplate()!; context: { $implicit: decade }"></ng-container>
        </ng-template>
    </p-datepicker>

    <!-- Loading overlay (optional) -->
    <div *ngIf="loading()" class="app-datepicker-loading">
        <i class="pi pi-spinner pi-spin"></i>
    </div>
</div>